import { render, staticRenderFns } from "./routePermissionEdit.vue?vue&type=template&id=ead337b0&scoped=true&"
import script from "./routePermissionEdit.vue?vue&type=script&lang=js&"
export * from "./routePermissionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead337b0",
  null
  
)

export default component.exports